export default __webpack_public_path__ + "static/media/pathR2L.37bf1a75.svg";